import axios from 'axios';

async function eventToEventStore({
  actor, verb, value, dataSource,
}) {
  const toSend = {
    actor, verb, value, dataSource,
  };
  toSend.dataSource = 'tj-client-web';

  await axios.post(`${process.env.VUE_APP_ZELDA_URI}/event`, toSend);
}

export default eventToEventStore;
